import React from 'react';
import { colors } from '../design-system/colors';

/**
 * Shared top banner for every page in the Login/Signup/Onboarding flow
 * (LoginPage, SignupPage, SignupSuccessPage, OnboardingWizard) -- the ONE
 * place this renders, so the four pages can never drift apart again.
 *
 * Bleeds to the `.setup-content` card's own edges (-mx-8/-mt-8 cancel
 * Setup.css's `p-8` exactly, same trick regardless of a page's own
 * setup-content max-width override), background is colors.buttonSecondary
 * (the Design System's own existing primary blue button color -- not a
 * new color), and the logo is the SAME asset the authenticated app's top
 * nav renders (App.tsx), so Login/Signup have real visual continuity into
 * the app rather than a re-created look-alike.
 */
export function AuthBanner() {
  return (
    <div
      className="-mx-8 -mt-8 mb-6 h-20 rounded-t-lg flex items-end justify-start px-6 pb-3"
      style={{ backgroundColor: colors.buttonSecondary }}
    >
      <img src="/KrewUp - Logo4.png" alt="KrewUp" className="h-7 w-auto" />
    </div>
  );
}
